// src/components/superadmin/BusinessCardsList.jsx
import React, { useState, useEffect } from 'react';
import { getAllBespokeStaff } from '../../api/superAdminApi';
import BusinessCardViewer from './BusinessCardViewer';

function BusinessCardsList() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedStaff, setSelectedStaff] = useState(null);

  useEffect(() => {
    loadStaff();
  }, []);

  const loadStaff = async () => {
    try {
      setLoading(true);
      setError('');
      const staffData = await getAllBespokeStaff();
      setStaff(staffData);
    } catch (err) {
      setError('Failed to load staff members');
      console.error('Error loading staff:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewCard = (staffMember) => {
    setSelectedStaff(staffMember);
  };

  const handleCloseViewer = () => {
    setSelectedStaff(null);
  };

  const handleRefresh = () => {
    loadStaff();
  };

  if (loading) {
    return <div className="loading-spinner">Loading business cards...</div>;
  }

  if (error) {
    return (
      <div className="error-message">
        {error}
        <button onClick={handleRefresh} style={{ marginLeft: '10px' }}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="business-cards-content">
      <div className="business-cards-header">
        <h2>Business Cards</h2>
        <p>Manage business cards for BespokeBridge team members</p>
        <button 
          onClick={handleRefresh} 
          className="refresh-button"
          style={{
            marginTop: '10px',
            padding: '8px 16px',
            background: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          Refresh List
        </button>
      </div>

      {staff.length === 0 ? (
        <div className="empty-state">
          <p>No staff members found. Add staff members to create business cards.</p>
        </div>
      ) : (
        <div className="business-cards-grid">
          {staff.map((staffMember) => (
            <div key={staffMember.id} className="business-card-item">
              <div className="card-item-header">
                <h3>{staffMember.name}</h3>
                <span className="card-item-title">{staffMember.title}</span>
              </div>
              <button 
                className="view-card-button"
                onClick={() => handleViewCard(staffMember)}
              >
                Show Business Card
              </button>
            </div>
          ))}
        </div>
      )}

      {selectedStaff && (
        <BusinessCardViewer 
          staff={selectedStaff}
          onClose={handleCloseViewer}
        />
      )}
    </div>
  );
}

export default BusinessCardsList;